function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rbiz-logo_svg__a",
  d: "M0 .195h10.373v14.731H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rbiz-logo_svg__c",
  d: "M.079.213h9.363v10.499H.079z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .066)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rbiz-logo_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rbiz-logo_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ED3024",
  d: "M5.187 8.284a2.887 2.887 0 01-2.884-2.879v-.023a2.887 2.887 0 012.718-2.878c.054.008.11.013.166.013A2.887 2.887 0 018.07 5.4a2.887 2.887 0 01-2.883 2.884m5.186-2.872V5.4A5.193 5.193 0 005.425.22a1.164 1.164 0 00-.238-.025A5.193 5.193 0 000 5.382v8.392a1.153 1.153 0 102.303 0V9.71a5.163 5.163 0 002.884.877A2.887 2.887 0 018.07 13.47v.304a1.15 1.15 0 102.302 0v-.304A5.178 5.178 0 008.44 9.435a5.18 5.18 0 001.933-4.023",
  mask: "url(#rbiz-logo_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F6AE1A",
  d: "M23.337 4.034c-.822 0-1.489.665-1.489 1.487v7.75a1.488 1.488 0 002.977-.001V5.521c0-.822-.666-1.487-1.488-1.487M23.311.257c-.94 0-1.672.529-1.672 1.39v.039c0 .86.733 1.409 1.672 1.409.94 0 1.671-.548 1.671-1.409v-.04c0-.86-.732-1.389-1.671-1.389"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.478 3.927)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rbiz-logo_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rbiz-logo_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F6AE1A",
  d: "M9.428 1.477V1.42c0-.705-.593-1.206-1.434-1.206H1.477A1.217 1.217 0 00.264 1.425a1.2 1.2 0 001.213 1.191h4.15L.748 8.005c-.47.51-.67.888-.67 1.456v.059c0 .704.616 1.192 1.457 1.192H8.23A1.2 1.2 0 009.443 9.52c0-.665-.548-1.21-1.213-1.21H3.884L8.77 2.926c.47-.51.658-.882.658-1.45",
  mask: "url(#rbiz-logo_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F6AE1A",
  d: "M18.17 10.642c0 1.219-1.007 1.734-2.6 1.734h-1.834V8.908h2.068c1.523 0 2.366.61 2.366 1.687v.047zm-4.434-8.048h1.715c1.523 0 2.366.609 2.366 1.687v.047c0 1.218-1.007 1.734-2.6 1.734h-1.481V2.594zm4.88 4.592c1.03-.577 1.826-1.484 1.826-3.112v-.041c0-.989-.33-1.793-.99-2.452C18.628.757 17.33.303 15.682.303H13.38v.003a2.587 2.587 0 00-2.487 2.696h-.003v9.138a2.588 2.588 0 002.49 2.585v.003h2.687v-.003c3.13-.059 5.177-1.376 5.177-3.953v-.042c0-1.937-.96-2.905-2.629-3.544z"
}));

function SvgRbizLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 18,
    viewBox: "0 0 36 16"
  }, props), _ref, _ref2);
}

export default SvgRbizLogo;